var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { FormError } from '../../errors';
import * as msg from '@lean-body/src/messages';
import { ButtonType } from '@lean-body/components/atoms';
import { StripeCardForm } from './stripe_card_form';
import { Colors } from '@lean-body/components/styles';
import { ArrowDirection, ArrowIcon } from '../atoms/icons/arrow_icon';
import { CCFormButton } from './cc_form_button';
import { CCFormAmazonPay } from './cc_form_amazon_pay';
import { useRefHooks } from '@lean-body/src/util';
export const CCFormSections = {
    amazonPay: 'amazonPay',
    stripe: 'stripe',
};
export const CCFormSubmitType = {
    firstPlan: 'firstPlan',
    secondaryPlan: 'secondaryPlan',
};
export const CCForm = ({ submitLabel, alertPresenter, onSubmit, config, children, basePlan, secondaryBasePlan, onSubmitSecondaryPlan, disableCCForm, campaign, disableSecondaryPlan, createSetupIntent, onSubmitAmazonPay, signedInAmazonPay, }) => {
    const [section, setSection] = React.useState(signedInAmazonPay ? CCFormSections.amazonPay : CCFormSections.stripe);
    const selectedAmazonPaySection = section === CCFormSections.amazonPay;
    const hiddenInput = useRefHooks();
    const [filledAllForm, setFilledAllForm] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [openAnotherPlan, setOpenAnotherPlan] = React.useState(false);
    const buttonType = selectedAmazonPaySection || filledAllForm ? ButtonType.primary : ButtonType.transparentPrimary;
    let buttonDisabled;
    if (disableCCForm || loading) {
        buttonDisabled = true;
    }
    else if (selectedAmazonPaySection) {
        buttonDisabled = false;
    }
    else {
        buttonDisabled = !filledAllForm;
    }
    const amazonPayPlan = basePlan === null || basePlan === void 0 ? void 0 : basePlan.amazonPayPlan;
    const secondaryPlan = secondaryBasePlan === null || secondaryBasePlan === void 0 ? void 0 : secondaryBasePlan.plan;
    React.useEffect(() => {
        if (signedInAmazonPay && amazonPayPlan) {
            setSection(CCFormSections.amazonPay);
        }
        else {
            setSection(CCFormSections.stripe);
        }
    }, [basePlan]);
    const beforeSubmit = (isLoading) => {
        setLoading(isLoading);
        return true;
    };
    const showErrorFromStripeInput = (errors) => {
        if (errors.length > 0) {
            const err = new FormError(void 0, errors.join('\n'));
            alertPresenter.showError(err, msg.INVALID_INPUT);
            setLoading(false);
            return;
        }
    };
    const afterSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(false);
    });
    const onClickBasePlan = (e) => {
        // Stripeの送信は StripeCardForm で handleSubmit()を実行している
        // どちらのプランを選択したか StripeCardForm で判定できるように、value をセットしている
        hiddenInput.element.value = CCFormSubmitType.firstPlan;
        // AmazonPayでログインしているユーザーで、AmazonPayの支払いを実行した際に、
        // stripe の form submit が実行されないように preventDefault()
        if (signedInAmazonPay && selectedAmazonPaySection) {
            setLoading(true);
            e.preventDefault();
            onSubmitAmazonPay(basePlan.amazonPayPlan.id);
        }
    };
    const onClickSecondaryPlan = (e) => {
        // Stripeの送信は StripeCardForm で handleSubmit()を実行している
        // どちらのプランを選択したか StripeCardForm で判定できるように、value をセットしている
        hiddenInput.element.value = CCFormSubmitType.secondaryPlan;
        // AmazonPayでログインしているユーザーで、AmazonPayの支払いを実行した際に、
        // stripe の form submit が実行されないように preventDefault()
        if (signedInAmazonPay && selectedAmazonPaySection) {
            setLoading(true);
            e.preventDefault();
            onSubmitAmazonPay(secondaryBasePlan.amazonPayPlan.id);
        }
        // "他のプランを表示する"が閉じないように実行
        e.stopPropagation();
    };
    return (React.createElement(React.Fragment, null,
        amazonPayPlan && signedInAmazonPay && (React.createElement(CCFormAmazonPay, { classObject: styles.amazonPayFormAbove, openSection: selectedAmazonPaySection, onClickSection: () => setSection(CCFormSections.amazonPay) })),
        React.createElement(StripeCardForm, { stripeAPIKey: config.stripeAPIKey, showErrorFromStripeInput: showErrorFromStripeInput, afterSubmit: afterSubmit, beforeSubmit: beforeSubmit, changeFilledAllForm: setFilledAllForm, openSection: section === CCFormSections.stripe, onClickSection: () => setSection(CCFormSections.stripe), hideSectionTitle: !!amazonPayPlan, hiddenInputRef: hiddenInput.ref, hiddenInputElement: hiddenInput.element, createSetupIntent: createSetupIntent, onSubmitFirstPlan: onSubmit, onSubmitSecondaryPlan: onSubmitSecondaryPlan },
            amazonPayPlan && !signedInAmazonPay && (React.createElement(CCFormAmazonPay, { classObject: styles.amazonPayFormBelow, openSection: selectedAmazonPaySection, onClickSection: () => setSection(CCFormSections.amazonPay) })),
            children,
            React.createElement(CCFormButton, { buttonType: buttonType, disabled: buttonDisabled, loading: loading, submitLabel: submitLabel, basePlan: basePlan, campaign: campaign, config: config, selectedSection: section, signedInAmazonPay: signedInAmazonPay, onClick: onClickBasePlan }),
            !disableSecondaryPlan && (secondaryPlan === null || secondaryPlan === void 0 ? void 0 : secondaryPlan.isStandardPlan()) && (React.createElement("div", { className: css(styles.anotherPlan, openAnotherPlan && styles.anotherPlanOpened), onClick: () => setOpenAnotherPlan(!openAnotherPlan), "data-test": "openAnotherPlan" },
                React.createElement("div", { className: css(styles.displayAnotherPlan) },
                    "\u4ED6\u306E\u30D7\u30E9\u30F3\u3092\u8868\u793A\u3059\u308B",
                    React.createElement(ArrowIcon, { classObject: styles.arrowIcon, direction: openAnotherPlan ? ArrowDirection.top : ArrowDirection.bottom })),
                React.createElement(CCFormButton, { buttonType: buttonType, disabled: buttonDisabled, loading: loading, submitLabel: submitLabel, basePlan: secondaryBasePlan, onClick: onClickSecondaryPlan, dataTest: "submitSecondaryPlanInCCForm", config: config, selectedSection: section, signedInAmazonPay: signedInAmazonPay }))))));
};
const styles = StyleSheet.create({
    amazonPayFormAbove: {
        marginBottom: 10,
    },
    amazonPayFormBelow: {
        marginTop: 10,
    },
    anotherPlan: {
        maxHeight: 51,
        transition: 'all .2s',
        overflow: 'hidden',
    },
    anotherPlanOpened: {
        maxHeight: 500,
    },
    displayAnotherPlan: {
        fontSize: 14,
        fontWeight: 'bold',
        color: Colors.PrimaryDark,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '30px 0',
    },
    arrowIcon: {
        marginLeft: 10,
        width: 14,
        height: 8,
    },
});
